import CTASection from "../components/CTASection";
export default function Terms() {
  return (
    <div id="main-content" className="pt-20" data-testid="terms-page">
      <section className="py-32 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-gray-100" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Terms of Use
          </h1>
          <p className="text-sm text-gray-400 mb-8">Last Updated: January 2026</p>

          <div className="space-y-8 text-gray-300">
            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Acceptance of Terms</h2>
              <p className="text-gray-400">
                By accessing and using this website, you accept and agree to be bound by these Terms of Use. 
                If you do not agree to these terms, please do not use this website.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Use of Website</h2>
              <p className="text-gray-400 mb-4">
                This website is provided for informational and educational purposes only. You agree to use this website:
              </p>
              <ul className="space-y-2 text-gray-400 text-sm ml-6">
                <li className="list-disc">In compliance with all applicable laws and regulations</li>
                <li className="list-disc">Without attempting to gain unauthorized access to any systems</li>
                <li className="list-disc">Without interfering with the proper functioning of the website</li>
                <li className="list-disc">Without transmitting harmful code or malicious content</li>
              </ul>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">No Advisory Relationship</h2>
              <p className="text-gray-400">
                The content on this website does not constitute investment advice or create an advisory relationship. 
                We are distributors of mutual fund and SIF products only. Any investment decisions you make are solely your responsibility.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Intellectual Property</h2>
              <p className="text-gray-400">
                All content on this website, including text, graphics, logos, images, and software, is the property of 
                Kredere Family Office Private Limited or its licensors and is protected by copyright and intellectual property laws.
              </p>
              <p className="text-gray-400 mt-4">
                You may not reproduce, distribute, modify, or create derivative works without our prior written consent.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Limitation of Liability</h2>
              <p className="text-gray-400 mb-4">
                To the fullest extent permitted by law, Kredere Family Office Private Limited shall not be liable for:
              </p>
              <ul className="space-y-2 text-gray-400 text-sm ml-6">
                <li className="list-disc">Any direct, indirect, incidental, or consequential damages</li>
                <li className="list-disc">Loss of profits, revenue, data, or business opportunities</li>
                <li className="list-disc">Errors or omissions in website content</li>
                <li className="list-disc">Interruption or unavailability of the website</li>
                <li className="list-disc">Actions taken based on information from this website</li>
              </ul>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Third-Party Links</h2>
              <p className="text-gray-400">
                This website may contain links to third-party websites. These links are provided for convenience only. 
                We do not endorse or control these websites and are not responsible for their content or practices.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Disclaimer of Warranties</h2>
              <p className="text-gray-400">
                This website is provided "as is" without warranties of any kind, either express or implied, including but not limited to 
                warranties of merchantability, fitness for a particular purpose, or non-infringement.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Indemnification</h2>
              <p className="text-gray-400">
                You agree to indemnify and hold harmless Kredere Family Office Private Limited, its officers, directors, employees, 
                and agents from any claims, damages, losses, or expenses arising from your use of this website or violation of these terms.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Governing Law and Jurisdiction</h2>
              <p className="text-gray-400">
                These Terms of Use shall be governed by and construed in accordance with the laws of India. 
                Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Mumbai, India.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Changes to Terms</h2>
              <p className="text-gray-400">
                We reserve the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting. 
                Your continued use of the website after changes constitutes acceptance of the modified terms.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Severability</h2>
              <p className="text-gray-400">
                If any provision of these Terms of Use is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}